/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";

export default function PinnedMessageBanner({ messages, message, onJump, t, inline = false, topOffset = 8 }) {
  const pins = Array.isArray(messages) && messages.length ? messages : message?.id ? [message] : [];
  const pinIds = pins.map((pin) => pin.id).join(",");
  const [activeIndex, setActiveIndex] = useState(0);
  const [hasJumped, setHasJumped] = useState(false);

  useEffect(() => {
    setActiveIndex(0);
    setHasJumped(false);
  }, [pinIds]);
  if (!pins.length) return null;

  const selectedIndex = Math.min(activeIndex, pins.length - 1);
  const selected = pins[selectedIndex];
  const preview = String(selected.text || "").trim() ||
    t?.("chats.event_chat.pinned.attachment", { defaultValue: "Attachment" });

  const jump = () => {
    const targetIndex = hasJumped && pins.length > 1 ? (selectedIndex + 1) % pins.length : selectedIndex;
    setActiveIndex(targetIndex);
    setHasJumped(true);
    onJump?.(pins[targetIndex].id);
  };

  return (
    <button
      type="button"
      onClick={jump}
      className={`${inline ? "relative mx-4 mt-2 shrink-0 lg:mx-6" : "absolute inset-x-4 lg:inset-x-6"} z-20 flex min-h-[52px] items-center gap-3 rounded-full border border-white/15 bg-[#192747]/95 px-4 py-2 text-left text-white shadow-[0_8px_24px_rgba(0,0,0,0.25)] backdrop-blur-sm transition active:scale-[0.99]`}
      style={inline ? undefined : { top: topOffset }}
      aria-label={t?.("chats.event_chat.pinned.jump", { defaultValue: "Jump to pinned message" })}
      data-testid="chat-pinned-message"
    >
      {pins.length > 1 ? (
        <span className="flex h-9 w-1 shrink-0 flex-col justify-center gap-[3px]" aria-hidden="true">
          {pins.map((pin, index) => (
            <span
              key={pin.id}
              data-pin-index={index}
              data-active={index === selectedIndex ? "true" : "false"}
              className={`block h-[8px] w-[3px] rounded-full transition-colors ${index === selectedIndex ? "bg-white" : "bg-white/35"}`}
            />
          ))}
        </span>
      ) : null}
      <span className="min-w-0 flex-1">
        <span className="block text-[11px] font-bold text-white">
          {t?.("chats.event_chat.pinned.label", { defaultValue: "Pinned message" })}
        </span>
        <span className="block truncate text-[13px] leading-5">{preview}</span>
      </span>
      <img src="/assets/menu/chat_pin.svg" width="20" height="20" alt="" aria-hidden="true" className="shrink-0 opacity-85" />
    </button>
  );
}
